import { Head, Link } from "@inertiajs/react";

import { Button } from "@/components/ui/button";
import AppLayout from "@/layouts/app-layout";
import { invoicesPath } from "@/routes";
import type {
  BreadcrumbItem,
  Invoice,
  PagyMetadata,
  RansackFilters,
} from "@/types";

import { InvoicesDataTable } from "./data-table";

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Facturas",
    href: invoicesPath(),
  },
];

interface InvoicesProps {
  data: {
    invoices: Invoice[];
    pagy: PagyMetadata;
  };
  filters: RansackFilters;
}

export default function Invoices({ data, filters }: InvoicesProps) {
  const { invoices, pagy } = data;

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Facturas" />
      <div className="flex h-full flex-1 flex-col gap-4 p-4">
        <div className="flex flex-col space-y-2">
          <h2 className="text-2xl font-bold">Facturas</h2>
          <p className="text-muted-foreground">
            Gestiona las facturas y su procesamiento
          </p>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Total: {pagy.count} facturas
          </div>
          <div className="flex gap-2">
            <Button asChild>
              <Link href="/invoices/upload_new">Nueva Factura</Link>
            </Button>
          </div>
        </div>

        <InvoicesDataTable
          invoices={invoices}
          pagy={pagy}
          filters={filters}
        />
      </div>
    </AppLayout>
  );
}
